import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getSize, getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { parseThemeColor } from "./auth-service-tools206.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { getContrastColor } from "./auth-service-tools214.js";
import { getAutoContrastValue } from "./auth-service-tools215.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { extractStyleProps } from "./auth-service-tools237.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { InlineInput } from "./auth-service-tools315.js";
import { RadioCard } from "./auth-service-tools393.js";
import { useRadioGroupContext } from "./auth-service-tools394.js";
import { RadioGroup } from "./auth-service-tools395.js";
import { RadioIcon } from "./auth-service-tools396.js";
import { RadioIndicator } from "./auth-service-tools397.js";
import classes from "./auth-service-tools398.js";
import { useId } from "./auth-service-tools271.js";
const defaultProps = {
  labelPosition: "right"
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    size,
    radius,
    color,
    iconColor,
    variant,
    autoContrast
  } = _ref;
  const parsedColor = parseThemeColor({
    color: color || theme.primaryColor,
    theme
  });
  const outlineColor = parsedColor.isThemeColor && parsedColor.shade === void 0 ? `var(--mantine-color-${parsedColor.color}-outline)` : parsedColor.color;
  return {
    root: {
      "--radio-size": getSize(size, "radio-size"),
      "--radio-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--radio-color": variant === "outline" ? outlineColor : getThemeColor(color, theme),
      "--radio-icon-color": iconColor ? getThemeColor(iconColor, theme) : getAutoContrastValue(autoContrast, theme) ? getContrastColor({
        color,
        theme,
        autoContrast
      }) : void 0,
      "--radio-icon-size": getSize(size, "radio-icon-size")
    }
  };
});
const Radio = factory((_props, ref) => {
  var _a, _b;

  const props = useProps("Radio", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    id,
    size,
    label,
    labelPosition,
    description,
    error,
    radius,
    color,
    variant,
    disabled,
    wrapperProps,
    icon: Icon = RadioIcon,
    rootRef,
    iconColor,
    onChange,
    mod,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "Radio",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  const ctx = useRadioGroupContext();
  const contextSize = (_a = ctx == null ? void 0 : ctx.size) != null ? _a : size;
  const componentSize = props.size ? size : contextSize;
  const {
    styleProps,
    rest
  } = extractStyleProps(others);
  const uuid = useId(id);
  const contextProps = ctx ? {
    checked: ctx.value === rest.value,
    name: (_b = rest.name) != null ? _b : ctx.name,
    onChange: event => {
      ctx.onChange(event);
      onChange == null ? void 0 : onChange(event);
    }
  } : {};
  return /* @__PURE__ */jsxRuntimeExports.jsx(InlineInput, { ...getStyles("root"),
    __staticSelector: "Radio",
    __stylesApiProps: props,
    id: uuid,
    size: componentSize,
    labelPosition,
    label,
    description,
    error,
    disabled,
    classNames,
    styles,
    unstyled,
    "data-checked": contextProps.checked || void 0,
    variant,
    ref: rootRef,
    mod,
    ...styleProps,
    ...wrapperProps,
    children: /* @__PURE__ */jsxRuntimeExports.jsxs(Box, { ...getStyles("inner"),
      mod: {
        "label-position": labelPosition
      },
      children: [/* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...getStyles("radio", {
          focusable: true,
          variant
        }),
        onChange,
        ...rest,
        ...contextProps,
        component: "input",
        mod: {
          error: !!error
        },
        ref,
        id: uuid,
        disabled,
        type: "radio"
      }), /* @__PURE__ */jsxRuntimeExports.jsx(Icon, { ...getStyles("icon"),
        "aria-hidden": true
      })]
    })
  });
});
Radio.classes = classes;
Radio.displayName = "@mantine/core/Radio";
Radio.Group = RadioGroup;
Radio.Card = RadioCard;
Radio.Indicator = RadioIndicator;
export { Radio };